<div class="progress">
  <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" [ngStyle]="{width: value+'%'}" [attr.aria-valuenow]="value"
       aria-valuemin="0" aria-valuemax="100">{{ value }}%</div>
</div>
